// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__x39VF","wrapper":"Footer_wrapper__r6D3P"};